import React from 'react';
import { Oval } from 'react-loader-spinner';
import tokens from '../theme/tokens';

/**
 * Full-screen blocking loader.
 *
 * The body of this component had been commented out since before the 2026-08
 * restyle, so the five pages that call `{loading && <Loader />}` showed no
 * indicator at all during their fetch. It is restored here, on the brand
 * palette rather than the spinner library's default green.
 *
 * `fixed inset-0` rather than the old `absolute w-full h-full`: absolute
 * resolved against AppShell's `<main>`, so the overlay only covered the
 * visible slice of a scrolled page and scrolled away with the content. A
 * blocking loader should cover the viewport. The z-index clears the bottom
 * nav's `z-[999]` deliberately — input is meant to be blocked while loading.
 */
const Loader: React.FC = () => (
  <div
    className="fixed inset-0 z-[1000] flex items-center justify-center bg-brand-900/25"
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    <Oval
      height="64"
      width="64"
      color={tokens.brand[800]}
      secondaryColor={tokens.brand[300]}
      strokeWidth={4}
      ariaLabel="oval-loading"
      visible={true}
    />
  </div>
);

export default Loader;
